import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import { CookieBanner } from "@/components/CookieBanner";
import { initPixel, trackPageView } from "@/lib/pixel";

import HomePage from "@/pages/HomePage";
import AanbodPage from "@/pages/AanbodPage";
import CarDetailPage from "@/pages/CarDetailPage";
import InruilPage from "@/pages/InruilPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function PixelTracker() {
    const location = useLocation();
    useEffect(() => { trackPageView(); }, [location.pathname]);
    return null;
}

function App() {
    useEffect(() => { initPixel(); }, []);
    return (
        <AuthProvider>
            <BrowserRouter>
                <PixelTracker />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/aanbod" element={<AanbodPage />} />
                    <Route path="/auto/:id" element={<CarDetailPage />} />
                    <Route path="/inruil" element={<InruilPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/admin/login" element={<AdminLoginPage />} />
                    <Route path="/admin" element={<AdminDashboardPage />} />
                </Routes>
                <CookieBanner />
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </AuthProvider>
    );
}

export default App;
